import { useState } from "react";

const contactCards = [
  { title: "Call us", detail: "+91 98765 43210", note: "Mon-Fri, 9:00 AM - 7:00 PM IST" },
  { title: "Write to us", detail: "support@training.io", note: "Replies within one business day" },
  { title: "Visit", detail: "Orbit Tower, MG Road, Bengaluru", note: "By appointment only" },
];

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    setForm({ name: "", email: "", phone: "", message: "" });
  };

  return (
    <div className="contact-page page-section">
      <section className="contact-hero">
        <div>
          <p className="eyebrow">Contact us</p>
          <h1>Tell us about your next cohort or hiring plan.</h1>
          <p className="muted">
            Share your batch size, preferred start date, and the mix of skills you need - we will respond with a tailored
            rollout plan.
          </p>
          <div className="contact-cards">
            {contactCards.map((item) => (
              <div key={item.title} className="contact-card">
                <p className="small muted">{item.title}</p>
                <p className="stat-label">{item.detail}</p>
                <p className="small">{item.note}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="contact-form-card">
          <h3>Send a message</h3>
          <form className="contact-form" onSubmit={handleSubmit}>
            <label>
              Name
              <input name="name" value={form.name} onChange={handleChange} required />
            </label>
            <label>
              Email
              <input name="email" type="email" value={form.email} onChange={handleChange} required />
            </label>
            <label>
              Phone
              <input name="phone" value={form.phone} onChange={handleChange} />
            </label>
            <label>
              Message
              <textarea name="message" rows="4" value={form.message} onChange={handleChange} />
            </label>
            <button type="submit" className="primary">
              Send Message
            </button>
            {submitted && <p className="success-callout">Message sent successfully.</p>}
          </form>
        </div>
      </section>

      <section className="contact-info">
        <div className="info-block">
          <p className="eyebrow">Office hours</p>
          <h3>We respond fast.</h3>
          <p className="muted">
            Expect a reply within a business day. For urgent placement support, use the phone line above.
          </p>
        </div>
        <div className="map-panel">
          <iframe
            title="office-location"
            src="https://maps.google.com/maps?q=Bangalore&t=&z=13&ie=UTF8&iwloc=&output=embed"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
};

export default Contact;
